<!-- <section *ngIf="!isEpin && !channelWeb" infiniteScroll [scrollWindow]="false"
         [infiniteScrollDistance]="1" [infiniteScrollDisabled]="false"
         (scrolled)="onPageScroll()" [infiniteScrollContainer]=" channelWeb ? windowContainer : infiniteScrollContainer">
<div>
<div *ngIf="scrollToReview" tmoGoTopButton [goToTopRef]="'review-header'" [setScroll]="scrollToReview"></div>
<div class="row">
  <div class="col-12 m-t-xl">
    <h3 *ngIf="!dataFiltered" id="review-header">{{reviewsStaticContent?.reviews}} ({{reviewsData?.totalReviews || 0}})</h3>
    <h3 *ngIf="dataFiltered" id="review-header">{{reviewsStaticContent?.reviews}} ({{filteredReviewsCount || 0}})</h3>
    <div class="row">
      <div class="col-12 rating-select">
        <tmo-star-rating *ngIf="seeAllCta && reviewsData?.reviews?.length > 0" [rating]="reviewsData?.totalReviewsRate"
                         [showMegaStar]="true"></tmo-star-rating>
          <p class="m-t-sm" *ngIf ="!reviewsData?.reviews">{{reviewsStaticContent?.noReviewsAvailable}}</p>
      </div>
    </div>
</div>
<div class="col-12 button-spacing" *ngIf="channelWeb">
  <button id="write-reviews-button" (click)="navigateToBazaarVoiceWriteReview()" class="btn btn-secondary" attr.aria-label="{{reviewsStaticContent?.writeReview}}">{{reviewsStaticContent?.writeReview}}</button>
</div>
</div>
<div *ngIf="seeAllCta && reviewsData?.reviews?.length > 0" class="row m-t-xl">
  <div class="col-12">
    <hr class="divider">
  </div>
</div>
<div class="row" *ngIf="reviewsData?.totalReviews > 0">
  <div class="col-12">
    <div *ngIf="seeAllCta" class="row m-t-xl">
      <div class="col-9">
        <h4>{{reviewsStaticContent?.reviewsHeader}}</h4>
      </div>
      <div *ngIf="seeAllCta" class="col-3 text-end">
        <p class="p-t-sm">
          <a id="see-all-reviews-link" href="javascript:void(0)" (click)="navigateToReview()"  [ngClass]="reviewsData?.totalReviews > 4 ? '' : 'disabled'"
             attr.aria-label="{{reviewsStaticContent?.seeAllReviews}}">
            {{reviewsStaticContent?.seeAllReviews}}</a>
        </p>
      </div>
    </div>
    <div *ngFor="let review of reviewsData?.reviews;let reviewIndex = index;">
      <div class="row m-t-lg">
        <div class="col-12 rating-select">
          <tmo-star-rating [rating]=review?.reviewRate [showMegaStar]="true"></tmo-star-rating>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p class="bold m-t-sm">{{review?.reviewRateSummary}}</p>
          <p class="m-t-sm small">{{review?.reviewDate}} by {{review?.reviewUserName}}</p>
          <p class="m-t-lg">{{review?.reviewText}}</p>
          <p class="m-t-md" *ngIf="review?.pros?.length > 0">Pros: {{review?.pros.join(", ")}}</p>
          <p class="m-t-md" *ngIf="review?.cons?.length > 0">Cons: {{review?.cons.join(", ")}}</p>
          <p class="alert-text m-t-lg" *ngIf="review?.recommendToFriend">
            <i id="recommend-to-friend-image" class="fa fa-check alert-icon def icon-magenta"></i>
            {{reviewsStaticContent?.recommendToFriend}}
          </p>
        </div>
      </div>
      <div *ngIf="!seeAllCta" class="row m-t-lg">
          <div class="col-4 col-md-3">
              <i id="thumbs-up-image" class="fa fa-thumbs-up"></i><span class="m-l-xs">
              <a id="helpful-link" class="xsmall"
                 [ngClass]="{'disabled': disableThumbsUp[reviewIndex]}"
                 href="javascript:void(0);"
                 (click)="thumbCTAClick('thumbsUp',reviewIndex, review.id)"
                 attr.aria-label="{{reviewsStaticContent?.helpful}}">{{reviewsStaticContent?.helpful}} ({{review?.helpful}})</a></span>
          </div>
          <div class="col-4 col-md-3">
              <i id="thumbs-down-image" class="fa fa-thumbs-down"></i><span class="m-l-xs"><a class="xsmall"
 [ngClass]="{'disabled': disableThumbsDown[reviewIndex]}"
 href="javascript:void(0);"
 (click)="thumbCTAClick('',reviewIndex, review.id)"
 attr.aria-label="{{reviewsStaticContent?.unhelpful}}" id="cta-unhelpful-2_{{reviewIndex}}">{{reviewsStaticContent?.unhelpful}} ({{review?.unhelpful}})</a></span>
          </div>
          <div class="col-4 col-md-3">
              <i id="report-review" class="fa fa-flag"></i><span class="m-l-xs"><a class="xsmall" href="javascript:void(0);"
 attr.aria-label="{{reviewsStaticContent?.reportReview}}"
 (click)="showAppropriateModal(reviewIndex, $event);" id="cta-report-review-2_{{reviewIndex}}">{{reviewsStaticContent?.reportReview}} </a></span>
          </div>
      </div>
      <hr class="divider m-t-xl">
    </div>
    <div *ngIf="seeAllCta && reviewsData?.reviews?.length > 0" class="row">
      <div class="col-12 button-spacing">
        <button id="see-all-reviews-button" class="btn btn-secondary" [disabled]="reviewsData?.totalReviews <= 4" (click)="navigateToReview()" attr.aria-label="{{reviewsStaticContent?.seeAllReviews}}">
          {{reviewsStaticContent?.seeAllReviews}}</button>
      </div>
    </div>
  </div>
</div>
</div>
<tmo-dynamic-modal [modal]="modal" (onHide)="closeModal()">
    <ng-container header>
      <div class="modal-logo-close">
          <i id="cross-image" class="logo-icon t-icon t-icon-logo"></i>
          <a id="cross-image"tabindex="0" [attr.aria-label]="reviewsStaticContent?.clickToClose" href="javascript:void(0)"
             class="close-x pull-right" (click)="closeModal()">
          <i id="times-image" class="fa fa-times"></i></a>
      </div>
      <div class="row">
        <div class="col-12">
          <h3>{{reviewsStaticContent?.inappropriatePost}}</h3>
        </div>
      </div>
    </ng-container>
    <div class="row m-t-xs">
      <div class="col-12">
        <form [formGroup]="modalFormGroup">
        <textarea class="form-control"
                  id="about-inappropriate-review"
                  formControlName="reviewFeedBack"
                  placeholder="Tell us what was inappropriate about this review."
                  cols="10" rows="7" name="textarea"
                  aria-label="Textarea"></textarea>
        </form>
      </div>
  </div>
  <ng-container footer>
      <div class="col-12 buttons-container button-spacing">
          <div class="button-box">
            <button id="submit-button" class="btn btn-primary" aria-label="Clickable action" (click)="showFeedbackModal($event);">
              {{reviewsStaticContent?.submit}}</button>
          </div>
      </div>
    </ng-container>
  </tmo-dynamic-modal>
  <tmo-dynamic-modal [modal]="feedbackModal" (onHide)="closeFeedbackModal()">
      <ng-container header>
        <div class="modal-logo-close">
            <i id="close-logo" class="logo-icon t-icon t-icon-logo"></i>

            <a id="close-logo-link" tabindex="0" [attr.aria-label]="reviewsStaticContent?.clickToClose" href="javascript:void(0)"
               class="close-x pull-right" (click)="closeFeedbackModal()">
            <i id="times-logo" class="fa fa-times"></i></a>
        </div>
        <div class="row">
          <div class="col-12">
            <h3>{{reviewsStaticContent?.thanksForFeedback}}</h3>
          </div>
        </div>
      </ng-container>
      <div class="row">
          <div class="col-12">
              <p class="lead">{{reviewsStaticContent?.feedbackMessage}}</p>
            </div>
    </div>
    <ng-container footer>
        <div class="col-12 buttons-container button-spacing">
            <div class="button-box">
              <button id="close-feedback-button" class="btn btn-primary" aria-label="Clickable action" (click)="closeFeedbackModal()">{{reviewsStaticContent?.close}}</button>
            </div>
        </div>
      </ng-container>
    </tmo-dynamic-modal> -->
<!-- <tmo-spinner [setDelay]="reviewsStaticContent && reviewsData"></tmo-spinner> -->
<!-- <tmo-spinner [setDelay]="reviewsStaticContent && !showSpinner"></tmo-spinner>
</section> -->

<div class="row" *ngIf="showComponentSpinner">
  <div class="col-12 text-center">
    <i id="spinner-image" class="fa fa-spinner fa-pulse spinner-icon"></i>
  </div>
</div>
